export default "<div [className]=\"position\">\n  <img [src]=\"src\" [alt]=\"alt\" />\n</div>\n"